import { usePageActive } from '~/utils/active/use-page-active';
import { useCallback } from 'react';
import { ClickPosition, ClickPositionPrefix } from '../click-position';

export const useActiveToFeedForyou = (): ((
  position: ClickPosition | [ClickPositionPrefix, ClickPosition],
  id?: string,
) => void) => {
  const active = usePageActive();

  return useCallback((position, id) => {
    const enterPosition = Array.isArray(position) ? position[0] + position[1] : position;

    active({
      schemaOption: {
        pageType: 'feed',
        categoryId: 0,
      },
      ampExtra: {
        enter_position: enterPosition,
        enter_page_click_id: id || null,
      },
    });
  }, []);
};
